// extracted by mini-css-extract-plugin
export var active = "_2z-7";
export var container = "_2z-0";
export var evenWidth = "_2z-4";
export var large = "_2z-5";
export var outlet = "_2z-8";
export var slide = "_2z-2";
export var small = "_2z-6";
export var tab = "_2z-3";
export var tabs = "_2z-1";